<!-- 协议签署组件 -->
<template>
  <div>
    <!-- 滚动框 -->
    <div class="scrollBox">
      <div class="box" ref="imageTofile">
        <!-- 标题 -->
        <div class="title font-size-24 text-center">
          道路运输液体危险货物罐式车辆蒸洗服务协议
        </div>
        <!-- 正文 -->
        <div class="body font-size-14">
          <div>
            <div>甲方司机姓名：{{ agreementData.driverName }}</div>
            <div>身份证号：{{ agreementData.idCard }}</div>
            <div>车号：{{ agreementData.cardNumber }}</div>
          </div>
          <p>乙方：江苏苏豪丽天智储循环科技有限公司</p>
          <p style="text-indent: 2em">
            根据国家有关法律法规的规定，经甲、乙双方充分协商，本协议采用电子签约的方式订立。经甲、乙双方充分协商，双方就甲方委托乙方按照GB/T
            44705—2024标准进行道路运输液体危险货物罐式车辆（以下简称槽车）罐体进行清洗及相关技术服务事宜达成如下协议。
          </p>
          <p class="bold">一、权利与义务</p>
          <p>1.1 甲方指定乙方为其槽罐蒸洗服务提供场地及相关服务。</p>
          <p>
            1.2
            乙方需建立槽罐蒸洗服务的操作、个人劳动防护用品的配备和使用规定等程序和规范。所有操作人员须经过必要的安全培训和具有必要的操作技能。
          </p>
          <p>
            1.3
            甲方的槽罐进入乙方厂区前，甲方司机需进行蒸洗预约、车辆检查合格后方可进场作业，乙方有权根据产能单方调整预约时间。
          </p>
          <p>
            1.4
            <span class="red bold">
              甲方须如实告知乙方本次作业的车辆信息（比如：上一载货品名称等）若未如实告知，乙方有权拒绝作业或停止作业，因此产生的一切损失和法律后果均由甲方承担。
            </span>
          </p>
          <p>
            1.5
            甲方槽车进入乙方厂区至驶出前，由乙方负责槽罐的安全。若槽罐蒸洗期间，甲方擅自操作现场设备设施，乙方有权拒绝对槽罐进行作业且不承担因甲方操作不当或其他任何甲方原因以及不可抗力引起的损害责任。
          </p>
          <p class="bold">
            1.6
            槽车蒸洗作业存在影响蒸洗质量的多种不可控因素，乙方仅按甲方要求提供蒸洗服务，甲方知晓，因槽车罐体内部结构、材质等特殊性质，乙方的蒸洗作业服务不可能完全清除残留货物。乙方不对因货物残留造成的任何人身、财产损害承担任何责任。甲方认为乙方未按要求进行蒸洗作业的，应在离场前以书面形式告知甲方。
            <span class="red bold">
              甲方需在槽车验收后，车辆驶离前签署《道路运输液体危险货物罐式车辆清洗验收证明》，离场后视为服务合格。
            </span>
            甲方在离场后提出的异议，对乙方不具有任何约束力，无权据此向乙方主张任何形式的索赔或权利。
          </p>
          <p>
            1.7
            若本次服务为槽车蒸洗作业，则乙方在甲方结清所有费用后可根据甲方需要出具《道路运输液体危险货物罐式车辆清洗验收证明》。
          </p>
          <p class="bold">二、费用项目费率及结算</p>
          <p>作业品种：{{ agreementData.variety }}</p>
          <p v-if="isShowCarPrice">蒸洗费用：以签订的协议价格为准。</p>
          <p v-else>蒸洗费用：{{ agreementData.price }}元</p>
          <p>2.1 所有价格均为含税价格。</p>
          <p>
            2.2
            如需增加现场操作（如下舱等）则另行计费。乙方如需提供其他第三方服务项目（如商检报告、挖舱等），则需另行付费。甲方应当在车辆离场前结清所有费用。
          </p>
          <p>
            2.3
            甲方槽罐车进场时，对于蒸洗前槽罐内剩余残液，甲方车辆应提前卸除后再进场作业。若甲方不需要残液，则交由乙方收集处置，乙方将残液按照危废进行处置，按照25元/升收取成本费。
          </p>
          <p>
            三、其他未尽事宜，双方应本着相互合作、友好协商的态度协商解决，并可另行签订补充协议，补充协议书与本合同具有同等法律效力。若协商不成，任何一方可向江阴市人民法院提起诉讼解决。
          </p>
        </div>
        <div class="footer font-size-14">
          <div class="signDate">签约日期：{{ agreementData.singTime }}</div>
          <div class="signImg">
            <div class="text">司机姓名：</div>
            <div v-if="!imgUrl" class="signImgBox" @click="confirmSignature">
              签名展示区
            </div>
            <van-image
              v-else
              width="90"
              :src="imgUrl"
              @click="confirmSignature"
            />
          </div>
        </div>
      </div>
      <!-- 签名板 -->
      <steam-signature
        :isSignaturePadVisible="signaturePadVisible"
        :signOptions="options"
        @closePopup="closePopup"
        @saveSignature="saveSignature"
      />
    </div>
  </div>
</template>

<script>
  import SteamSignature from '@/components/SteamComponents/steamSignature.vue';
  import steamApi from '@/fetch/steamApi';
  import { Toast, Dialog } from 'vant';
  export default {
    components: {
      SteamSignature,
    },
    props: {
      agreementData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        imgUrl: '',
        signaturePadVisible: false,
        options: {
          penColor: '#000',
        },
        carName: '',
        isShowCarPrice: true
      };
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
      // console.log(this.$store);
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
      this.getCarBound()
    },
    methods: {
      async getCarBound() {
        this.carName = this.agreementData.cardNumber.split('/')[0]
        try {
          const res = await steamApi.getController(this.carName);
          const resData = JSON.parse(res)
          if(resData) {
            this.isShowCarPrice = resData.success
          }
        } catch (error) {
          Toast.fail('连接失败，请刷新页面')
          return false;
        }
      },
      openLoading() {
        this.$store.commit('set_isLoading', true);
        setTimeout(() => {
          this.$store.commit('set_isLoading', false);
        }, 3000);
      },
      saveSignature(data) {
        this.closePopup();
        this.imgUrl = data;
        // 触发自定义事件, 传递签名base64信息
        this.$emit('update-info', 'agreement', data);
      },

      closePopup() {
        this.signaturePadVisible = false;
      },

      confirmSignature() {
        this.signaturePadVisible = true;
      },

      // 导航栏返回
      onClickLeft() {
        this.$router.back();
      },
    },
  };
</script>
<style scoped lang="less">
  .navBar {
    ::v-deep .van-icon {
      color: #333;
    }
  }
  .box {
    background-color: #fff;
    padding: 1.25rem 1.25rem 0;
  }
  .title {
    font-weight: 700;
    margin-bottom: 1.25rem;
  }
  .body {
    line-height: 1.5em;
  }
  /* @import url(); 引入css类 */
  .font-size-24 {
    font-size: 1.5rem;
  }
  .font-size-14 {
    font-size: 0.875rem;
  }
  .red {
    color: red !important;
  }
  .bold {
    font-weight: 700;
    color: black;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .signImg {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .signBtn {
    padding: 0 30px;
  }
  .scrollBox {
    height: calc(100vh - 1rem - 56px - 84px);
    overflow-y: auto;
    -ms-overflow-style: none; /* IE/Edge */
    scrollbar-width: none; /* Firefox */
  }
  .scrollBox::-webkit-scrollbar {
    display: none; /* Chrome/Safari/Opera */
  }
  .signImgBox {
    width: 90px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #ccc;
    color: #ccc;
  }
</style>
